
<template>
  <div>
    <header>
      <p v-on:click="backHistory" style="margin-left: 1rem; " @click="">
        <!--<img src="@/assets/img/back.png" alt="">-->
        <span style="color: #FFFFFF">职位管理</span>
      </p>
      <!--<p>-->
      <div style="margin-right: 1rem">
        <router-link to="/releasePosition"> <van-icon background="#6e9bcf" color="#FFFFFF" name="plus"   /></router-link>
       <span style="color: #FFFFFF">发布</span>
      </div>
      <!--</p>-->
    </header>
    <div style="margin-top: 70px">
      <van-tabs v-model="activeName">
        <van-tab title=" 在线职位" name="a">
          <!--内容 1-->

          <div class="messageCenter" v-for="(index,key) in list" @click="toDetailPosition(index.id)">
            <div class="positionS">
              <div>{{index.name}} <span class="positionSpan">普通职位</span></div>
              <div style="padding-top: 0.5rem">
                <span class="positionSpan1">{{index.city}}</span>
                <span class="positionSpan1" v-if="index.work_year==1">不限</span>
                <span class="positionSpan1" v-else-if="index.work_year==2" >/1年以下</span>
                <span class="positionSpan1" v-else-if="index.work_year==3" >/1-3年</span>
                <span class="positionSpan1" v-else-if="index.work_year==4" >/3-5年</span>
                <span class="positionSpan1" v-else-if="index.work_year==5" >/5-10年</span>
                <span class="positionSpan1" v-else-if="index.work_year==6" >/10年以上</span>
                <span class="positionSpan1" v-if="index.edu==1" >/不限</span>
                <span class="positionSpan1" v-else-if="index.edu==2"  >/大专</span>
                <span class="positionSpan1" v-else-if="index.edu==3" >/本科</span>
                <span class="positionSpan1" v-else-if="index.edu==4" >/硕士</span>
                <span class="positionSpan1" v-else-if="index.edu==5" >/博士</span>
              </div>
              <!--1:不限 2：大专 3：本科 4：硕士 5：博士)-->
            </div>
            <div class="positionH">
             <span style="color: #00b38a">7</span>
             <span>候选人</span>

            </div>

          </div>
          <!--<div class="messageCenter">-->
            <!--<div class="positionS">-->
              <!--<div>前端 <span class="positionSpan">普通职位</span></div>-->
              <!--<span class="positionSpan1">北京13年</span>-->
            <!--</div>-->
            <!--<div class="positionH">-->
              <!--<span style="color: #00b38a">7</span>-->
              <!--<span>候选人</span>-->
            <!--</div>-->
          <!--</div>-->

          <!--</div>-->
        </van-tab>
        <van-tab title="已下线" name="b">

         </van-tab>
        <van-tab title="公司其他职位" name="c"></van-tab>
      </van-tabs>
    </div>
    <van-tabbar route >
      <van-tabbar-item replace to="/comTalents" icon="wap-home-o">
        招人才
      </van-tabbar-item>
      <van-tabbar-item replace to="/comMessage" icon="envelop-o">
        消息
      </van-tabbar-item>
      <van-tabbar-item replace to="/comPosition" icon="desktop-o">
        职位
      </van-tabbar-item>
      <van-tabbar-item replace to="/comMy" icon="contact">
        我的
      </van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'message',
    data () {
      return {
        msg: '',
        color:"#FFFFFF",
//        color:"#000000",
        bool:true,
        activeName: 'a',
//        active:0,
        list:{},
        name:'',
        uploadImages:[],
      }
    },
    mounted(){
      this.getComPositioner()
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      toDetailPosition(id){
        this.$router.push({
          path:"/comDetailsPosition",
          query:{
            id:id
          }
        })
      },
      getComPositioner(){
        this.$api.getComPosition({
          "user_id":localStorage.getItem("userid"),
//          "id":this.$route.params.id
        })
          .then(res=>{
            if(res.status==200){
              this.list=res.data
            }

          })
          .catch(res=>{
          })
      },
      upload(){
        this.$api.upload({
          "user_id":localStorage.getItem("userid"),
//          "id":this.$route.params.id
        })
          .then(res=>{
            if(res.status==200){
              this.list=res.data
            }

          })
          .catch(res=>{
          })
      },
      onRead(file) {
//        console.log(file);//file文件如下图
        var formData = new FormData();
//        console.log(formData)
        console.log(file)
//        console.log(file.file)// /构造一个 FormData，把后台需要发送的参数添加
        formData.append('image', file.file); //接口需要传的参数
        console.log(formData.get("image"))
//        console.log(formData.file)
//        this.$api.upload(
//          formData
//        )
//          .then(res => {//将formDate文件上传到阿里云服务器，会返回图片地址
//          console.log(res,111111);
////          let str = res.response_data[0];
////          this.uploadImages.push(str);//将图片地址存入一个数组中
//        });




//        axios.post("http://zpapi.yuexinduo.com/index/company/uploadLogo", formData, {headers: {
//          'Content-Type': 'multipart/form-data'
//        }}).then(res => {
//
//        })
        axios({
          url:"http://zpapi.yuexinduo.com/index/company/uploadLogo",
          method: 'post',
          data: formData,
          processData: false,// 告诉axios不要去处理发送的数据(重要参数)
          contentType: false,
          msg:1,// 告诉axios不要去设置Content-Type请求头
//          headers: {
//          'Content-Type': 'multipart/form-data'}
        }
        ).then((res)=>{
          console.log(res)
        })
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  .headerSpan{
    margin-left: 1rem;
    line-height: 10px;
    color: #FFFFFF;
  }
  header{
    width: 100%;
    height: 80px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*padding: 0 1rem;*/

    z-index: 100;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
.messageCenter{
 display: flex;
  align-items: center;
  justify-content: space-between;
  /*padding: 0px 1rem;*/
  width: 90%;
  margin: auto;
  margin-top: 1rem;
  border-bottom: solid 1px #DEDEDE;
}
  .positionSpan{
    font-size: 12px;
    background: #dce6f0;
    color: #44B389;
    padding: 2px 2px;
    border-radius: 8px;
  }
  .positionSpan1{
    /*display: flex;*/
     padding-top: 8px;
    font-size: 13px;
    color: grey;
  }
  .positionH{
    font-size: 15px;
  }
  .positionH span{
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/comPosition.vue